import React from "react";
import { css } from "glamor";
import DownloadsSection from "./DownloadsSection";
import { Spinner, spacing } from "../library";

const sectionsContainer = css({
  "@media (min-width: 768px)": {
    width: "100%",
  },
});

const spinnerStyle = {
  display: "flex",
  justifyContent: "center",
  width: "100% !important",
  marginTop: spacing.xxl,
};

const emptyMessageStyle = {
  textAlign: "center",
  marginTop: spacing.xl,
};

export default function DownloadsCourseSections({
  loading,
  courseFiles,
  lessonFiles,
}) {
  return (
    <div className={sectionsContainer}>
      {loading ? (
        <Spinner
          text="Carregando arquivos..."
          style={spinnerStyle}
          size="small"
          inline
          wrapped
        />
      ) : (
        <>
          {!courseFiles.length && !lessonFiles.length && (
            <p style={emptyMessageStyle}>Sem downloads para esse curso</p>
          )}
          <DownloadsSection
            title="Arquivos do Curso"
            files={courseFiles}
            alwaysOpen
          />
          <DownloadsSection
            title="Arquivos de Aula"
            hint="Os arquivos abaixo estão anexados com as aulas seguindo a sequência."
            files={lessonFiles}
          />
        </>
      )}
    </div>
  );
}
